export const KATA_GRADES = [
  "1er Dan",
  "2ème Dan",
  "3ème Dan",
  "4ème Dan",
  "5ème Dan",
  "6ème Dan",
  "7ème Dan",
  "8ème Dan",
  "9ème Dan",
  "10ème Dan",
];

export const KATA_TYPES = [
  "Nage-no-kata",
  "Katame-no-kata",
  "Kime-no-kata",
  "Kodokan Goshin Jutsu",
  "Ju-no-kata",
  "Koshiki-no-kata",
  "Itsutsu-no-kata",
  "Autre kata",
];

export const KATA_ROLE_OPTIONS = [
  {
    value: "indifferent",
    label: "Je recherche un Tori ou un Uke",
    shortLabel: "Tori ou Uke",
  },
  {
    value: "tori",
    label: "Je recherche un Tori",
    shortLabel: "Recherche Tori",
  },
  {
    value: "uke",
    label: "Je recherche un Uke",
    shortLabel: "Recherche Uke",
  },
];

export const KATA_SORT_OPTIONS = [
  {
    value: "newest",
    label: "Annonces les plus récentes",
  },
  {
    value: "oldest",
    label: "Annonces les plus anciennes",
  },
  {
    value: "name",
    label: "Nom du judoka",
  },
  {
    value: "grade",
    label: "Grade préparé",
  },
];

export const GRADE_IMAGES = {
  "1er Dan": "/images/belt/ceinture_judo_1D.png",
  "2ème Dan": "/images/belt/ceinture_judo_2D.png",
  "3ème Dan": "/images/belt/ceinture_judo_3D.png",
  "4ème Dan": "/images/belt/ceinture_judo_4D.png",
  "5ème Dan": "/images/belt/ceinture_judo_5D.png",
  "6ème Dan": "/images/belt/ceinture_judo_rouge_blanche.png",
  "7ème Dan": "/images/belt/ceinture_judo_rouge_blanche.png",
  "8ème Dan": "/images/belt/ceinture_judo_rouge.png",
  "9ème Dan": "/images/belt/ceinture_judo_rouge.png",
  "10ème Dan": "/images/belt/ceinture_judo_rouge.png",
};

export const DEFAULT_GRADE_IMAGE = "/img/default_image.jpg";